// Eleman tipi → ikon + görünen ad (katman listesi ve palet için).
import { SOURCE_FIELDS } from './fieldCatalog';

export const ELEMENT_ICON = {
  field: '🔗',
  'static-text': 'T',
  line: '─',
  box: '▭',
  image: '🖼',
  barcode: '▥',
  calc: 'Σ',
  'amount-words': '✎',
};

export function elementIcon(type) { return ELEMENT_ICON[type] || '•'; }

// Katman listesinde gösterilecek kısa ad.
export function elementDisplayName(el) {
  switch (el.type) {
    case 'field': {
      const g = SOURCE_FIELDS[el.source];
      const f = g?.fields.find((x) => x.key === el.fieldKey);
      return f?.label || el.fieldKey || 'Alan';
    }
    case 'static-text': return el.text ? `“${el.text.slice(0, 18)}”` : 'Metin';
    case 'line': return 'Çizgi';
    case 'box': return 'Kutu';
    case 'image': return 'Resim';
    case 'barcode': return `Barkod (${el.format || 'CODE128'})`;
    case 'calc': return 'Hesap';
    case 'amount-words': return 'Yazıyla Tutar';
    default: return el.type;
  }
}
